import React from 'react'
import './student-onboarding-task-card-2023.css'
import { createEllipses } from '../../utilityFunctions';
import { format } from 'date-fns';

const StudentOnboardingTaskCard2023 = ({card, setStudentOnboardingModal, labels, showSchoolsOnCards, setToolTip, calendarEvents}) => {

    const calculateDaysSincePutOnWaitlist = (card) => {
        const today = new Date();
        if(card.whichList === 'waitlist' && card.waitlistEntity) {
            const daysSince = Math.floor((today - new Date(card.waitlistEntity.startDate)) / (1000 * 60 * 60 * 24));
            return <div className='days-on-waitlist__badge'>{daysSince} Days</div>
        } else if(card.whichList === 'inquiry') {
            if(Math.floor((today - new Date(card.todoDueDate)) / (1000 * 60 * 60 * 24)) > 2) {
                return <div className='days-on-waitlist__badge'>{Math.floor((today - new Date(card.todoDueDate)) / (1000 * 60 * 60 * 24))} Days</div>
            }
        }
    }

    const checkForRecurringExceptions = (event) => {
        if(event.recurringExceptions) {
            for(let i = 0; i < event.recurringExceptions.length; i++) {
                if(format(new Date(event.recurringExceptions[i]), 'MM/dd/yyyy') === format(new Date(event.dateTime), 'MM/dd/yyyy')) {
                    return true
                }
            }
        }
        return false
    }

    const findIntroLesson = () => {
        //find all calendarEvents that have the same familyId as the card
        //console.log(card.familyId + ' ' + card.todoName)
        const events = calendarEvents.filter(event => event.familyId === card.familyId)
        let dateStyleObject = {future: false, date: ''}

        //if lesson date is in the past two weeks, return the date
        const today = new Date();
        const twoWeeksAgo = new Date(today.getDate() - 14);
        const pastIntroLesson = events.filter(event => (new Date(event.dateTime) > twoWeeksAgo) && (new Date(event.dateTime) < today) && event.isIntro)
        if(pastIntroLesson) {
            for(let i = 0; i < pastIntroLesson.length; i++) {
                if(!checkForRecurringExceptions(pastIntroLesson[i])) {
                    dateStyleObject.date = format(new Date(pastIntroLesson[i].dateTime), 'MM/dd')
                    dateStyleObject.future = false
                    return dateStyleObject
                }
            }
        }
        //if lesson date is in the future, return the date
        const futureIntroLesson = events.filter(event => new Date(event.dateTime) > today && event.isIntro)
        if(futureIntroLesson) {
            for(let i = 0; i < futureIntroLesson.length; i++) {
                if(!checkForRecurringExceptions(futureIntroLesson[i])) {
                    dateStyleObject.date = format(new Date(futureIntroLesson[i].dateTime), 'MM/dd')
                    dateStyleObject.future = true
                    return dateStyleObject
                }
            }
        }

    }


    let dateStyleObject = findIntroLesson()

    return(
        <div className='student-onboarding-task-card-2023' id={card.todoId} onMouseEnter={() => setToolTip(card)} onMouseLeave={() => setToolTip(false)} onClick={() =>setStudentOnboardingModal(card)}>
            <div className='student-onboarding-task-card-2023__user-wrapper'>
                <div className='student-onboarding-task-card-2023__user' id={`user-${card.todoId}`}>{labels[card.todoId] && labels[card.todoId].split(' ')[0]}</div>
            </div>
            <div className='student-onboarding-task-card-2023__info-wrapper'>
                <div className='student-onboarding-task-card-2023__title'>{createEllipses(card.todoName, 18)}</div>
                <div>
                {showSchoolsOnCards && !dateStyleObject && <div className='student-onboarding-task-card-2023__school'>{card.whichSchool.toUpperCase()}</div>}
                {card.whichList === 'intro' && dateStyleObject && <div className='student-onboarding-task-card-2023__school' style={dateStyleObject?.future ? {backgroundColor: '#F1F5F9'} : {backgroundColor: '#FFEDD5'}} >{dateStyleObject?.date}</div>}
                {calculateDaysSincePutOnWaitlist(card)}
                </div>
                {(card.whichList === 'orange' || card.todoDescription === 'Reassign') && <div className='student-onboarding-task-card-2023__status-badge'>Reassign</div>}
                {(card.whichList === 'blue' || card.todoDescription === 'Old Student') && <div className='student-onboarding-task-card-2023__status-badge old-student'>Old Student</div>}
                {(card.todoDescription === '4 free' || card.todoDescription === '2 free' || card.todoDescription === '1 free') && <div className='student-onboarding-task-card-2023__status-badge ad-offer'>{card.todoDescription.toUpperCase()}</div>}
            </div>
            {/* {card.hasIntroHappened && <div style={card.hasIntroHappened === 'called' ? {backgroundColor: 'green'} : {backgroundColor: '#F59E0B'}} className='student-onboarding-task-card-2023__intro-lesson-dot'></div>} */}
        </div>
    )
}
export default StudentOnboardingTaskCard2023